import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles, Avatar } from "@material-ui/core";
import { IUser } from "../core/redux/dataMap/user";

interface IAvatarProps {
  user: IUser;
  size: "lg" | "sm";
}

export const CustomAvatar: React.FC<IAvatarProps> = ({ user, size }) => {
  const classes = useStyles();
  const [initials, setInitials] = useState("-");

  useEffect(() => {
    if (user) {
      const userInitials = `${user.firstName.toLocaleUpperCase()[0]}${
        user.lastName.toLocaleUpperCase()[0]
      }`;
      setInitials(userInitials);
    }
  }, [user]);
  if (user && user.image)
    return (
      <Avatar
        alt="user-avatar"
        src={user.image}
        className={size === "lg" ? classes.large : classes.small}
      />
    );
  return (
    <Avatar className={size === "lg" ? classes.large : classes.small}>
      {initials}
    </Avatar>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    small: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    large: {
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  })
);
